import './App.scss'
// import "antd/dist/antd.css";
import 'antd/dist/antd.min.css'
// import 'react-summernote/dist/react-summernote.css'
import { BrowserRouter } from 'react-router-dom'
import { ProjectRoutes } from './routes'

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ProjectRoutes />
            </BrowserRouter>
        </div>
    )
}

export default App
